import { render } from "./Navbor.vue?vue&type=template&id=fdbfd79a&scoped=true"
import script from "./Navbor.vue?vue&type=script&lang=js"
export * from "./Navbor.vue?vue&type=script&lang=js"

import "./Navbor.vue?vue&type=style&index=0&id=fdbfd79a&scoped=true&lang=css"

import exportComponent from "/home/atom/Works/renny/rotto-web-admin/Front-End/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdbfd79a"]])

export default __exports__